import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=7fbb0b97&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=7fbb0b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbb0b97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbb0b97')) {
      api.createRecord('7fbb0b97', component.options)
    } else {
      api.reload('7fbb0b97', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=7fbb0b97&scoped=true&", function () {
      api.rerender('7fbb0b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/GuestBox.vue"
export default component.exports